/**
 * `/$org/apps/probe/interviews`: the old All interviews page, now Home's
 * interviews (`?show=interviews`), so bookmarks and links keep working.
 *
 * @module routes/$org.apps.probe.interviews.index
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$org/apps/probe/interviews/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$org/apps/probe/practice",
      params: { org: params.org },
      search: { show: "interviews" },
      replace: true,
    });
  },
});
